import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import PropTypes from "prop-types";
import * as InventaryService from "../../../../services/InventaryService";
import { useTranslation } from "react-i18next";
import ExpeditionProcessForm from "./expeditionProcessForm.view";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import moment from "moment-timezone";
import * as ExpeditionProcessService from "../../../../services/expeditionProcessService";
// import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const ExpeditionProcessFormContainer = ({ data, onSuccess, isDcoop }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    setInitValues(data);
  }, []);

  const loadData = useCallback(async () => {}, [setInitialValues, data]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        // let result = await InventaryService.newInventary(values);
        let result = await ExpeditionProcessService.newExpeditionProcess(values);


        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.expeditionProcess.messages.create.title");
          text = t("forms.expeditionProcess.messages.create.success");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.expeditionProcess.messages.create.error");
          icon = "error";
        }

        let okAction = () => {
          onSuccess();
        };
        showDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      console.log("Error", error);
      showDialog(
        "Error",
        error.data.error.code === "ARTICLE.NOT_FOUND" ? t("forms.expeditionProcess.messages.create.articleNotFound") : t("forms.expeditionProcess.messages.create.error"),
        "error",
        false,
        "OK",
        false
      );
    }
  };

  const handleOnback = (popupName) => {
    dispatch(hide(popupName));
  };

  return (
    <>
      <ExpeditionProcessForm
        initialValues={initValues}
        onSubmit={handleSubmit}
        onback={handleOnback}
      />
    </>
  );
};

ExpeditionProcessFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ExpeditionProcessFormContainer;